<template>
  <div class="wrapper">
    <div v-if="loading"
         class="circular-loader">
      <base-circular-loader color="primary"
                            size="medium" />
    </div>

    <div v-else
         class="tab-page">
      <blocks-and-alerts-list v-if="blocksAndAlerts.length"
                              :deviceEvents="blocksAndAlerts"
                              :mode-id="child.current_rule.mode_id" />
                              
      <blocks-and-alerts-empty-screen v-else
                                      :loading="loading"
                                      @retry="onRetry" />
    </div>
  </div>
</template>

<script>
  import BlocksAndAlertsList               from './BlocksAndAlertsList.vue'
  import BlocksAndAlertsEmptyScreen        from './BlocksAndAlertsEmptyScreen.vue'

  import analytics from '@/services/analytics.js'

  export default {
    props: {
      childId: {
        type: String,
        required: true
      }
    },

    components: {
      BlocksAndAlertsList,
      BlocksAndAlertsEmptyScreen
    },

    data() {
      return {
        loading: false
      }
    },

    created() {
      analytics.sendEvent('BlkAlrtRpt_Tb')

      this.loadBlocksAndAlerts()
    },

    computed: {
      ...mapGetters('children', {
        getChildById: 'getById',
        getBlocksAndAlerts: 'getBlocksAndAlerts'
      }),

      blocksAndAlerts() {
        return this.getBlocksAndAlerts(this.childId)
      },

      child() {
        return this.getChildById(this.childId)
      },
    },

    methods: {
      async loadBlocksAndAlerts() {
        this.loading = true

        await this.setBlocksAndAlerts({
          user_id: this.childId,
          event_names: ['block', 'warn']
        })

        this.loading = false
      },

      onRetry() {
        this.loadBlocksAndAlerts()
      },

      ...mapActions('children', {
        setBlocksAndAlerts: 'setBlocksAndAlerts'
      })
    },

    watch: {
      childId() {
        this.loadBlocksAndAlerts()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    height: 100%;
    width: 100%;

    .circular-loader {
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    .tab-page {
      height: 100%;
      width: 100%;
    }
  }
</style>